import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import { FormikInput, FormikSwitch, FormikSelect } from "../../../components/formik-components";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import {
  TaxTypeEnum
} from "../../../constants/appConstant";
import { useNavigate } from "react-router-dom";
import { respEnum } from "../../../constants/appConstant";


const FormikInitialValues = {
  name: "",
  type: TaxTypeEnum.Inclusive,
  percentage: "",
  isactive: true,
};

const formikValidation = yup.object({
  name: yup
    .string()
    .trim()
    .required("Tax Name is required")
    .max(100, "Tax name cannot exceed 100 characters"),
  type: yup.number().required("Tax Type is required"),
  percentage: yup
    .number()
    .required("Percentage is required")
    .min(0, "Percentage cannot be negative")
    .max(100, "Percentage cannot exceed 100"),
  isactive: yup.boolean(),
});

const AddTax = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

 const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
      name:d.name.trim(),
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateTax",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/taxes", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    let response = await Common.ApiService.getInstance().request(
      `GetTaxList?id=${id}`,
      {},
      "GET"
    );

    if (response.status === respEnum.Success && response.data && response.data.length > 0) {
      const taxData = response.data[0];
      formikRef.current.setValues({
        name: taxData.name || "",
        type: taxData.type || TaxTypeEnum.Inclusive,
        percentage: taxData.percentage || "",
        isactive: taxData.isactive !== undefined ? taxData.isactive : true,
      });
    }
  };

  useEffect(() => {
    if (id && isFormikInitialized && open) {
      getDataInfo();
    } else if (!id && isFormikInitialized && open) {
      formikRef.current?.setValues(FormikInitialValues);
    }
  }, [id, isFormikInitialized, open]);


  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            Add Tax
          </Button>
        </DialogTrigger>
        <DialogContent
          ref={dialogRef}
          className="max-h-[100vh] overflow-y-auto sm:max-w-[500px] overflow-x-visible"
        >
          <DialogHeader>
            <DialogTitle className="text-base font-medium flex items-center gap-2">
              <Icon
                className="h-5 w-5 text-blue-600"
              />
              {!id ? "Add New" : "Update"} Tax
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500 space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(formikProps) => (
                <div className="flex flex-col gap-4">
                  <FormikInput
                    formikProps={formikProps}
                    name={"name"}
                    label={"Tax Name"}
                    placeholder={"Enter Tax Name"}
                  />

                  <FormikSelect
                    formikProps={formikProps}
                    name={"type"}
                    label={"Tax Type"}
                    placeholder={"Select Tax Type"}
                    data={Common.Utility.enumToArray(TaxTypeEnum).filter(type=>type.id===TaxTypeEnum.Inclusive)}
                  />

                  <FormikInput
                    formikProps={formikProps}
                    name={"percentage"}
                    label={"Percentage (%)"}
                    placeholder={"Enter Percentage"}
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                  />

                  <FormikSwitch
                    formikProps={formikProps}
                    name={"isactive"}
                    label={"Active"}
                  />
                </div>
              )}
            </Formik>
          </div>

          <DialogFooter className="mt-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Cancel
              </Button>
            </DialogClose>
            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddTax;

